import { useQuery } from '@tanstack/react-query'
import { accountMapRulesOptions } from './getAccountMapRulesOptions'

export const useAccountMapRules = ({ companyId }: { companyId: string }) => {
  const options = accountMapRulesOptions(companyId)
  return useQuery(options)
}
